import * as React from 'react';

import { navigationProvider } from '@40seas/payments-shared';
import { Box } from '@mui/material';
import { Button } from 'react-admin';

export const WrongUrl: React.FC<{ email?: string }> = ({ email }: { email?: string }) => {
    return (
        <Box maxHeight="100dvh" display="grid">
            <h2>
                This link cannot be accessed
                <br />
                through your account
                <br />
                {email}
            </h2>

            <Box>
                For any questions please contact <br />
                <a href="mailto:support@40seas.com" target="_blank" rel="noopener noreferrer">
                    support@40seas.com
                </a>{' '}
            </Box>
            <br />
            <Button variant="contained" label="Go to dashboard" onClick={() => navigationProvider.navigationToDashboard()} />
        </Box>
    );
};
